import { X } from "@phosphor-icons/react";

export function Button({ children, variant = "primary", className = "", ...props }) {
  const base =
    "inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-md text-sm font-semibold transition-all active:scale-95 disabled:opacity-50 disabled:pointer-events-none";
  const variants = {
    primary: "bg-cyan text-black hover:bg-[#5AF0FF]",
    ghost: "bg-transparent text-[#A1A1AA] hover:text-white hover:bg-white/[0.05]",
    outline: "border border-white/15 text-white hover:bg-white/[0.05]",
    danger: "bg-expense/15 text-expense hover:bg-expense/25 border border-expense/20",
  };
  return (
    <button className={`${base} ${variants[variant]} ${className}`} {...props}>
      {children}
    </button>
  );
}

export function Input({ label, className = "", ...props }) {
  return (
    <label className="block">
      {label && <span className="block text-xs font-medium text-[#A1A1AA] mb-1.5">{label}</span>}
      <input
        className={`w-full bg-[#0A0A0A] border border-white/10 rounded-md px-3 py-2.5 text-sm text-white placeholder:text-[#52525B] outline-none transition-colors focus:border-cyan/50 focus:ring-2 focus:ring-cyan/20 ${className}`}
        {...props}
      />
    </label>
  );
}

export function Select({ label, children, className = "", ...props }) {
  return (
    <label className="block">
      {label && <span className="block text-xs font-medium text-[#A1A1AA] mb-1.5">{label}</span>}
      <select
        className={`w-full bg-[#0A0A0A] border border-white/10 rounded-md px-3 py-2.5 text-sm text-white outline-none transition-colors focus:border-cyan/50 focus:ring-2 focus:ring-cyan/20 ${className}`}
        {...props}
      >
        {children}
      </select>
    </label>
  );
}

export function Card({ children, className = "" }) {
  return (
    <div className={`bg-surface border border-white/10 rounded-md ${className}`}>{children}</div>
  );
}

export function Modal({ open, onClose, title, children }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} />
      <div
        data-testid="modal"
        className="relative w-full max-w-md bg-surface border border-white/10 rounded-md shadow-2xl animate-fade-up"
      >
        <div className="flex items-center justify-between px-5 py-4 border-b border-white/10">
          <h3 className="font-heading font-bold text-lg">{title}</h3>
          <button onClick={onClose} data-testid="modal-close" className="text-[#52525B] hover:text-white transition-colors">
            <X size={20} />
          </button>
        </div>
        <div className="p-5">{children}</div>
      </div>
    </div>
  );
}

export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="flex items-end justify-between gap-4 mb-8">
      <div>
        <h1 className="font-heading font-extrabold text-3xl md:text-4xl tracking-tighter leading-none">{title}</h1>
        {subtitle && <p className="text-[#A1A1AA] text-sm mt-2">{subtitle}</p>}
      </div>
      {children}
    </div>
  );
}
